module.exports = __webpack_public_path__ + "static/media/dove.b3bccff7.svg";